/**
 * Bridge Add-flow ghost thumbs into the live Featured Carousel strip so the
 * page does not flash “No posts” while refreshLiveData + strip fetch catch up.
 */

import type { FeaturedCarouselItem } from "./types";

const pendingBySlug = new Map<string, FeaturedCarouselItem[]>();

export function seedPendingFeedStrip(
  slug: string,
  thumbs: Array<{
    image?: string;
    title?: string;
    isText?: boolean;
    platform?: string;
    postDate?: string;
    mediaUrl?: string;
    isVideo?: boolean;
    postType?: string;
    shopLink?: string;
    shopCtaLabel?: "Shop" | "View" | "Watch";
  }>,
  opts?: { asProduct?: boolean },
) {
  const key = String(slug || "").trim();
  if (!key) return;
  const asProduct = Boolean(opts?.asProduct);
  const items = thumbs
    .map((t, i) => {
      const image = String(t.image || "").trim();
      const isText = Boolean(t.isText) && !image && !asProduct;
      if (!image && !isText) return null;
      const mediaUrl = String(t.mediaUrl || "").trim();
      return {
        id: `pending-${key}-${i}`,
        title: String(t.title || "").trim() || key,
        image,
        slug: key,
        kind: (asProduct ? "shop" : "content") as "shop" | "content",
        ...(asProduct
          ? { postType: "PRODUCT", productImage: image }
          : {}),
        ...(mediaUrl ? { mediaUrl, isVideo: Boolean(t.isVideo) } : {}),
        ...(t.shopLink ? { shopLink: t.shopLink } : {}),
        ...(t.shopCtaLabel ? { shopCtaLabel: t.shopCtaLabel } : {}),
        ...(isText
          ? {
              isText: true as const,
              platform: t.platform,
              postDate: t.postDate,
              postType: t.postType,
            }
          : {
              ...(t.platform ? { platform: t.platform } : {}),
              ...(t.postDate ? { postDate: t.postDate } : {}),
              ...(!asProduct && t.postType ? { postType: t.postType } : {}),
            }),
      };
    })
    .filter(Boolean) as FeaturedCarouselItem[];
  if (!items.length) return;
  pendingBySlug.set(key, items);
}

export function peekPendingFeedStrip(
  slug: string,
): FeaturedCarouselItem[] | null {
  const key = String(slug || "").trim();
  if (!key) return null;
  return pendingBySlug.get(key) || null;
}

export function clearPendingFeedStrip(slug: string) {
  const key = String(slug || "").trim();
  if (!key) return;
  pendingBySlug.delete(key);
}
